import React from 'react'
import Header from '../Component/Header';
import Footer from '../Component/Footer';
import MarketPlaceBody from '../Component/MarketPlaceBody';

const MarketPlace = () => {
  return (
    <div>
        <Header/>
        <MarketPlaceBody/>
        <Footer/>
    </div>
  )
}

export default MarketPlace;